import React from "react";

import { FaChalkboardTeacher } from "react-icons/fa";
import "./style.scss";
import clsx from "clsx";

function EventIcon({ size }) {
  return (
    <FaChalkboardTeacher
      className={clsx(
        size && size === "large"
          ? "event-icon-one"
          : size && size === "listSize"
          ? "event-icon-list"
          : size && size === "sidebarlistSize"
          ? "event-icon-sidebar-list"
          : size && size === "scroller"
          ? "scroller-list-icons"
          : "event-icon-two",
        "d-flex jusitify-content-center align-items-center"
      )}
    />
  );
}

export default EventIcon;
